// src/hooks/programs/useGetProgram.js
import { useQuery } from "@tanstack/react-query";
import { getProgram } from "../../api/apiPrograms";
import i18next from "i18next";

const useGetProgram = (id) => {
    const { data, error, isLoading } = useQuery({
        queryKey: ["program", id, i18next.language],
        queryFn: () => getProgram(id),
        enabled: !!id,
    });

    return {
        program: data?.data || null,
        error,
        isLoading,
    };
};

export default useGetProgram;
